import { Icon, Intent } from "@blueprintjs/core"
import { ID } from "src/libs/interfaces/layouts"
import { PETestQuestion } from "src/modules/pe-tests-module/data/interfaces"
import { ITestsStore, useTestsStore } from "src/modules/pe-tests-module/data/store"

/* Protopia Ecosystem component */
export interface IRangeListResultProps {
    item: PETestQuestion
    i:number
}
const RangeListResult = ({item, i, ...props}: IRangeListResultProps): JSX.Element => {
    const results: any[]   = useTestsStore((state:ITestsStore) => state.results)
    // console.log( results[i] )
    const answer = item.answers.find(a => a.id === results[i]?.answer_id)
    const rate = Math.floor( results[i]?.value / 100 * item.range )
    const fill = answer?.id === item.answers[0].id ? "#3587e9" : "#549c54"
    return <div className="text-right strob01 py-2 w-100 position-relative" >
        <span className="small descr- text-force-contrast mr-4 ">
            { answer?.title }
            {/* <span className="mx-2 opacity_5">|</span> 
            <span className="opacity_5">{ answer?.pe_test_category && answer?.pe_test_category[0]?.id }</span> */}
        </span>
        <span className="title position-relative" style={{color: fill}}>
            {rate}
            <div 
                className="w-100 position-absolute left" 
                style={{ height: 3, bottom: -6, backgroundColor:fill }}
            />
        </span>
        <div 
            className="w-100 position-absolute left d-none" 
            style={{ height:1, bottom: 7, backgroundColor:fill }}
        />
    </div>
}
export default RangeListResult